import React from 'react'
import Routes from './routes'
import 'bootstrap/dist/css/bootstrap.min.css';
// eslint-disable-next-line
export default () => < Routes /> ;